/** Third-party CSS/JS entry → vendor.css + vendor.bundle.js (webpack and esbuild). */
import './ts/jquery-global';
import './ts/vendor-setup';
